module.exports = __webpack_public_path__ + "img/Elven_Spear_01.439d7bd5.png";